const onlineShopping = {
  'onlineShopping-1': 'Tienda en línea',
  'onlineShopping-2': 'Próximamente'
};

export default onlineShopping;
